import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import db from "../firebase";
import { useState } from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { useNavigate, useParams } from "react-router-dom/dist";
import SearchIcon from "@mui/icons-material/Search";
import { styled } from "@mui/material/styles";
import { blue } from "@mui/material/colors";
import { makeStyles } from "@mui/styles";
import AddIcon from "@mui/icons-material/Add";
import { Button, IconButton } from "@mui/material";
import CottageIcon from "@mui/icons-material/Cottage";
import Navbar from "./Navbar";
import RestartAltIcon from '@mui/icons-material/RestartAlt';

const useStyles = makeStyles({
  root: {
    "& .MuiDataGrid-columnsContainer": {
      backgroundColor: "#E8EAF6",
    },
    "& .MuiDataGrid-iconSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "bold",
    },
  },
});

export default function MonthlyReports() {
  const [rows, setRows] = useState([]);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [view, setView] = useState(false);
  var monthFilter = useParams();

  useEffect(() => {
    (async () => {
      const colRef = collection(db, "reports");
      const snapshots = await getDocs(colRef);
      const docs = snapshots.docs.map((doc) => {
        let data = doc.data();
        data.id = doc.id;
        return data;
      });
      setRows(docs);
    })();
  }, []);


  var getMonth = parseInt(monthFilter.monthName, 10)
  const filteredMonth = rows.filter((item) => {
    var itemMonth = item.month;
    console.log(itemMonth)
    console.log(getMonth)
    return itemMonth === getMonth;
  });
  const filteredData = filteredMonth.sort((a, b) => a.id - b.id);
  const filteredRows = filteredData.filter((row) => {
    const searchTermLower = searchTerm.toLowerCase();
    
    return (
      searchTermLower === "" ||
      (row.subject && row.subject.toLowerCase().includes(searchTermLower)) ||
      (row.date &&
        row.date.toString().toLowerCase().includes(searchTermLower)) ||
      (row.userName && row.userName.toLowerCase().includes(searchTermLower)) ||
      (row.amount && row.amount.toLowerCase().includes(searchTermLower)) ||
      (row.description &&
        row.description.toLowerCase().includes(searchTermLower))
    );
  });
  console.log(filteredRows);
  const getTotalAmountByStatus = (subject) => {
    return filteredRows.reduce((total, item) => {
      if (item.subject === subject) {
        return total + Number(item.amount);
      }
      return total;
    }, 0);
  };

  const totalExpense = getTotalAmountByStatus("Expense");
  const totalIncome = getTotalAmountByStatus("Income");

  const handleViewClose = () => {
    setView(false);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setVisible(true);
  };

  const handleReset = () => {
    setSearchTerm("");
    setVisible(false);
  };

  const AddButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(blue[500]),
    backgroundColor: "#1f1966",
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: "#1f1979",
    },
  }));

  const handleNav = () => {
    navigate("/index");
  };

  return (
    <>
      <div className="container">
        <Button
          startIcon={<CottageIcon />}
          onClick={handleNav}
          variant="contained"
          sx={{ position: "relative", top: "-20px", width: "400px" }}
        >
          Home
        </Button>
        <SearchIcon className="search-icon" />
        <input
          id="search"
          type="text"
          value={searchTerm}
          placeholder="Search..."
          onChange={handleSearch}
        />
        {/* {visible && (
          <IconButton
            className="reset"
            aria-label="delete"
            onClick={handleReset}
          >
            <RestartAltIcon />
          </IconButton>
        )} */}
        <div style={{ position: "relative", top: "-40px", left: "120px" }}>
          <span style={{ color: "green" }}>Total Income</span>
          <span
            style={{ color: "green", position: "relative", left: "4.75px" }}
          >
            {" "}
            :{" "}
          </span>
          <span style={{ position: "relative", top: "1px", left: "4.5px" }}>
            {totalIncome}
          </span>
          <br></br>
          <span style={{ color: "red" }}>Total Expense</span>
          <span style={{ color: "red" }}> : </span>
          <span style={{ position: "relative", top: "1px" }}>
            {totalExpense}
          </span>
        </div>
        {filteredRows.map((i) => {
          return (
            <Accordion key={i.id}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography>{i.userName}</Typography>
                {i.subject === "Income" && (
                  <span
                    style={{ position: "absolute", left: "335px", top: "11px" }}
                  >
                    <ArrowUpwardIcon />
                  </span>
                )}
                {i.subject === "Expense" && (
                  <span
                    style={{ position: "absolute", left: "335px", top: "11px" }}
                  >
                    <ArrowDownwardIcon />
                  </span>
                )}
                <div>
                <span
                  style={{
                    color: i.subject === "Expense" ? "red" : "green",
                    position: "absolute",
                    top: "13px",
                    left: "295px",
                    textAlign: "right",
                  }}
                >
                  {i.amount}
                </span>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <Typography sx={{ fontWeight: "700" }}>
                  {i.subject} - {i.date} - {i.time}
                </Typography>
                <Typography>{i.description}</Typography>
                {/* <Typography sx={{fontWeight: "700"}} >{i.user}</Typography> */}
              </AccordionDetails>
            </Accordion>
          );
        })}
      </div>
    </>
  );
}


